export const isValidInviteToken = (s: unknown): s is string => {
  if (!s || typeof s !== 'string') return false

  return s.length > 40
}
